// Reiter "Zusammengeführt": alle Zusammenführungen, auch die, die Close selbst gemacht hat. Eine im CRM gemachte lässt sich rückgängig
// machen, solange beide Leads noch da sind.
import { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { dublettenApi, type Zusammenfuehrung } from "../api/dubletten";
import { useEchtzeit } from "../api/echtzeit";
import { Laden, Leer, Zeit } from "../components/Bausteine";
import { FehlerBox } from "../components/Fehler";
import { useMeldung } from "../components/Meldungen";
import { Bestaetigen } from "./Bestaetigen";
import { TX, umfangText } from "./texte";

export function ProtokollListe() {
  const meldung = useMeldung();
  const [zeilen, setZeilen] = useState<Zusammenfuehrung[] | null>(null);
  const [cursor, setCursor] = useState<string | null>(null);
  const [fehler, setFehler] = useState<unknown>(null);
  const [rueck, setRueck] = useState<Zusammenfuehrung | null>(null);

  const laden = useCallback(async () => {
    try {
      const r = await dublettenApi.protokoll({ limit: 30 });
      setZeilen(r.data);
      setCursor(r.has_more ? r.cursor : null);
      setFehler(null);
    } catch (e) {
      setFehler(e);
    }
  }, []);
  useEffect(() => {
    void laden();
  }, [laden]);
  useEchtzeit(["lead.merged"], () => void laden());

  const mehr = async () => {
    if (!cursor) return;
    try {
      const r = await dublettenApi.protokoll({ limit: 30, cursor });
      setZeilen((z) => [...(z ?? []), ...r.data]);
      setCursor(r.has_more ? r.cursor : null);
    } catch (e) {
      meldung.fehler(e, "Nicht geladen");
    }
  };

  return (
    <>
      {fehler ? <FehlerBox fehler={fehler} onNochmal={() => void laden()} /> : null}
      {!zeilen && !fehler ? <Laden /> : null}
      {zeilen && !zeilen.length ? <Leer titel={TX.keinProtokoll} text={TX.keinProtokollText} /> : null}
      {zeilen?.length ? (
        <table className="tabelle tabelle--einfach dub-protokoll">
          <thead>
            <tr>
              <th>Wann</th>
              <th>Zusammengeführt</th>
              <th>Wer</th>
              <th>Was wanderte</th>
              <th />
            </tr>
          </thead>
          <tbody>
            {zeilen.map((z) => (
              <tr key={z.id}>
                <td>
                  <Zeit iso={z.ts} />
                </td>
                <td className={z.rueckgaengig_at ? "dub-rueck" : ""}>
                  <Link className="dub-name" to={`/lead/${encodeURIComponent(z.ziel_lead_id)}`}>
                    {z.ziel_name ?? z.ziel_lead_id}
                  </Link>
                  <span className="dub-zusatz">
                    ← {z.quelle_name ?? z.quelle_lead_id}
                  </span>
                </td>
                <td>
                  {z.quelle === "close" ? <span className="leise">{TX.ausClose}</span> : (z.user_name ?? "–")}
                  {z.rueckgaengig_at ? <span className="dub-zusatz">rückgängig gemacht <Zeit iso={z.rueckgaengig_at} nurRelativ /></span> : null}
                </td>
                <td className="leise">{umfangText(z.umfang) || (z.quelle === "close" ? "in Close zusammengeführt" : "–")}</td>
                <td className="rechts">
                  {z.kann_rueckgaengig ? (
                    <button type="button" className="knopf knopf--klein" onClick={() => setRueck(z)}>
                      {TX.rueckgaengig}
                    </button>
                  ) : null}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      ) : null}
      {cursor ? (
        <div className="dub-mehr">
          <button type="button" className="knopf" onClick={() => void mehr()}>
            {TX.ladeMehr}
          </button>
        </div>
      ) : null}
      <Bestaetigen
        titel={TX.rueckgaengig}
        offen={!!rueck}
        text={TX.rueckgaengigFrage}
        knopf={TX.rueckgaengig}
        onNein={() => setRueck(null)}
        onJa={async () => {
          if (!rueck) return;
          await dublettenApi.rueckgaengig(rueck.id);
          setRueck(null);
          meldung.ok("Zusammenführung rückgängig gemacht.");
          await laden();
        }}
      />
    </>
  );
}
